import { createContext } from "react";

export const GlobalConfigContext = createContext();